/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type { QueryFunction, QueryKey, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import type {
  AvailableChartKindsResp,
  AvailableDistributionRangesResp,
  AvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetParams,
  AvailableGranularitiesResp,
  AvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetParams,
  AvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetParams,
  AvailableVisualizationsResp,
  HTTPValidationError,
  ReportsAvailableBreakdownsResp,
  ReportsAvailableVariablesResp,
} from '../model';

import { customFetch } from '../../fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetUrl = (
  projectId: string,
  params: AvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/reports/${projectId}/available/visualizations?${stringifiedParams}`
    : `/api/v1/reports/${projectId}/available/visualizations`;
};

/**
 * @summary Available Visualizations
 */
export const availableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGet = async (
  projectId: string,
  params: AvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AvailableVisualizationsResp> => {
  return customFetch<AvailableVisualizationsResp>(
    getAvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetUrl(projectId, params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getAvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetQueryKey = (
  projectId: string,
  params?: AvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetParams,
) => {
  return [`/api/v1/reports/${projectId}/available/visualizations`, ...(params ? [params] : [])] as const;
};

export const getAvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof availableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params: AvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetQueryKey(projectId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof availableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGet>>
  > = ({ signal }) =>
    availableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGet(projectId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof availableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof availableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGet>>
>;
export type AvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetQueryError = HTTPValidationError;

/**
 * @summary Available Visualizations
 */

export function useAvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGet<
  TData = Awaited<ReturnType<typeof availableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params: AvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAvailableVisualizationsApiV1ReportsProjectIdAvailableVisualizationsGetQueryOptions(
    projectId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetUrl = (
  projectId: string,
  params?: AvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/reports/${projectId}/available/granularities?${stringifiedParams}`
    : `/api/v1/reports/${projectId}/available/granularities`;
};

/**
 * @summary Available Granularities
 */
export const availableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGet = async (
  projectId: string,
  params?: AvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AvailableGranularitiesResp> => {
  return customFetch<AvailableGranularitiesResp>(
    getAvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetUrl(projectId, params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getAvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetQueryKey = (
  projectId: string,
  params?: AvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetParams,
) => {
  return [`/api/v1/reports/${projectId}/available/granularities`, ...(params ? [params] : [])] as const;
};

export const getAvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof availableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: AvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetQueryKey(projectId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof availableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGet>>
  > = ({ signal }) =>
    availableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGet(projectId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof availableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof availableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGet>>
>;
export type AvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetQueryError = HTTPValidationError;

/**
 * @summary Available Granularities
 */

export function useAvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGet<
  TData = Awaited<ReturnType<typeof availableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: AvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAvailableGranularitiesApiV1ReportsProjectIdAvailableGranularitiesGetQueryOptions(
    projectId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAvailableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGetUrl = (
  projectId: string,
) => {
  return `/api/v1/reports/${projectId}/available/distribution_ranges`;
};

/**
 * @summary Available Distribution Ranges
 */
export const availableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGet = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<AvailableDistributionRangesResp> => {
  return customFetch<AvailableDistributionRangesResp>(
    getAvailableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGetUrl(projectId),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getAvailableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGetQueryKey = (
  projectId: string,
) => {
  return [`/api/v1/reports/${projectId}/available/distribution_ranges`] as const;
};

export const getAvailableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof availableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAvailableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGetQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof availableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGet>>
  > = ({ signal }) =>
    availableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGet(projectId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof availableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AvailableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof availableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGet>>
>;
export type AvailableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGetQueryError =
  HTTPValidationError;

/**
 * @summary Available Distribution Ranges
 */

export function useAvailableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGet<
  TData = Awaited<ReturnType<typeof availableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAvailableDistributionRangesApiV1ReportsProjectIdAvailableDistributionRangesGetQueryOptions(
    projectId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAvailableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGetUrl = (
  projectId: string,
) => {
  return `/api/v1/reports/${projectId}/available/analytics/chart-kinds`;
};

/**
 * @summary Available Analytics Chart Kinds
 */
export const availableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGet = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<AvailableChartKindsResp> => {
  return customFetch<AvailableChartKindsResp>(
    getAvailableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGetUrl(projectId),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getAvailableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGetQueryKey = (
  projectId: string,
) => {
  return [`/api/v1/reports/${projectId}/available/analytics/chart-kinds`] as const;
};

export const getAvailableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof availableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAvailableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGetQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof availableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGet>>
  > = ({ signal }) =>
    availableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGet(projectId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof availableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AvailableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof availableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGet>>
>;
export type AvailableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGetQueryError =
  HTTPValidationError;

/**
 * @summary Available Analytics Chart Kinds
 */

export function useAvailableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGet<
  TData = Awaited<ReturnType<typeof availableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAvailableAnalyticsChartKindsApiV1ReportsProjectIdAvailableAnalyticsChartKindsGetQueryOptions(
    projectId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAvailableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGetUrl = (projectId: string) => {
  return `/api/v1/reports/${projectId}/available/breakdowns`;
};

/**
 * @summary Available Breakdowns
 */
export const availableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGet = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReportsAvailableBreakdownsResp> => {
  return customFetch<ReportsAvailableBreakdownsResp>(
    getAvailableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGetUrl(projectId),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getAvailableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGetQueryKey = (projectId: string) => {
  return [`/api/v1/reports/${projectId}/available/breakdowns`] as const;
};

export const getAvailableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof availableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAvailableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGetQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof availableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGet>>
  > = ({ signal }) =>
    availableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGet(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof availableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AvailableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof availableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGet>>
>;
export type AvailableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGetQueryError = HTTPValidationError;

/**
 * @summary Available Breakdowns
 */

export function useAvailableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGet<
  TData = Awaited<ReturnType<typeof availableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAvailableBreakdownsApiV1ReportsProjectIdAvailableBreakdownsGetQueryOptions(
    projectId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetUrl = (
  projectId: string,
  params: AvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/reports/${projectId}/available/variables?${stringifiedParams}`
    : `/api/v1/reports/${projectId}/available/variables`;
};

/**
 * @summary Available Variables
 */
export const availableVariablesApiV1ReportsProjectIdAvailableVariablesGet = async (
  projectId: string,
  params: AvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReportsAvailableVariablesResp> => {
  return customFetch<ReportsAvailableVariablesResp>(
    getAvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetUrl(projectId, params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getAvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetQueryKey = (
  projectId: string,
  params?: AvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetParams,
) => {
  return [`/api/v1/reports/${projectId}/available/variables`, ...(params ? [params] : [])] as const;
};

export const getAvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof availableVariablesApiV1ReportsProjectIdAvailableVariablesGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params: AvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableVariablesApiV1ReportsProjectIdAvailableVariablesGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetQueryKey(projectId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof availableVariablesApiV1ReportsProjectIdAvailableVariablesGet>>
  > = ({ signal }) =>
    availableVariablesApiV1ReportsProjectIdAvailableVariablesGet(projectId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof availableVariablesApiV1ReportsProjectIdAvailableVariablesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof availableVariablesApiV1ReportsProjectIdAvailableVariablesGet>>
>;
export type AvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetQueryError = HTTPValidationError;

/**
 * @summary Available Variables
 */

export function useAvailableVariablesApiV1ReportsProjectIdAvailableVariablesGet<
  TData = Awaited<ReturnType<typeof availableVariablesApiV1ReportsProjectIdAvailableVariablesGet>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params: AvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableVariablesApiV1ReportsProjectIdAvailableVariablesGet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAvailableVariablesApiV1ReportsProjectIdAvailableVariablesGetQueryOptions(
    projectId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}
